<div class="container" style="margin-top: 40px; text-align: center;">
  <ng-container [ngSwitch]="status">
    <div *ngSwitchCase="'carregando'">
      <p>Confirmando e-mail...</p>
    </div>
    <div *ngSwitchCase="'sucesso'" style="color: green;">
      <h2>{{ mensagem }}</h2>
    </div>
    <div *ngSwitchCase="'erro'" style="color: red;">
      <h2>{{ mensagem }}</h2>
    </div>
  </ng-container>
</div>